import Markdoc from "@markdoc/markdoc";
import type { LoaderArgs } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { Box, Container, Heading, Stack } from "@chakra-ui/react";
import { useEffect } from "react";

export async function loader({ request }: LoaderArgs) {
  const requestOrigin = new URL(request.url).origin;
  const markdown = await fetch(
    `${requestOrigin}/policies/20230605-eula.md`,
  ).then(res => res.text());
  return json({ markdown });
}

export default function TermsOfUse() {
  const { markdown } = useLoaderData<typeof loader>();
  const markdownAst = Markdoc.parse(markdown);
  const content = Markdoc.transform(markdownAst, {});
  const html = Markdoc.renderers.html(content);

  useEffect(() => {
    const _window: any = window;
    if (window) {
      _window.parent.postMessage("SCROLLED_TO_BOTTOM_OF_EULA_DOC");
    }
  }, []);

  return (
    <Container as={Stack} p={10} spacing={8} maxW={"4xl"} border={"none"}>
      <Heading>Please read & agree to our Terms of Use</Heading>
      <div dangerouslySetInnerHTML={{ __html: html }} />
      <Box h={8} />
    </Container>
  );
}
